import { wellhub } from '@gympass/tai-chi';
import '@gympass/tai-chi/index.css';
import type { PropsWithChildren } from 'react';

import MuiThemeProvider from '@mui/material/styles/ThemeProvider';
import CssBaseline from '@mui/material/CssBaseline';
import darkScrollbar from '@mui/material/darkScrollbar';
import type { Theme } from '@mui/material/styles';
import { cssReset } from './cssReset';

const mergeThemes = {
  ...wellhub,
  components: {
    ...wellhub.components,
    MuiCssBaseline: {
      styleOverrides: (themeParam: Theme) => ({
        ...cssReset,
        body: themeParam.palette.mode === 'dark' ? darkScrollbar() : null,
        'html, body, #root': {
          minHeight: ['100vh', '100svh'],
        },
      }),
    },
  },
};

export function ThemeProvider({ children }: PropsWithChildren) {
  return (
    <MuiThemeProvider theme={mergeThemes}>
      <CssBaseline enableColorScheme />

      {children}
    </MuiThemeProvider>
  );
}
